export const CookieDuration = 604800000 // 7 days in milliseconds

// Sovendus
export const sovReqToken = 'sovReqToken'

// Veneficus Network (vn)
export const VNCookie = 'ota-vn'

// Spaaza
export const SpaazaToken = 'ref'

// Cashback UK/Clickwork
export const ClickWorkToken = 'cashbackid'
export const ClickWorkCookie = 'ota-cb'

// Digital Mojo / Everflow
export const EverflowToken = 'eftid'
export const EverflowCookie = 'ota-eftid'

// Orange Buddies
export const OrangeBuddiesToken = 'sunid'
export const OrangeBuddiesCookie = 'ota-sunid'

// Everflow Client
export const EverflowClientToken = 'tid'
export const EverflowClientCookie = 'ota-efcid'
export const EverflowClientSubIDCookie = 'ota-efcsubid'
export const EverflowClientAdditionalParametersCookie = 'ota-efap'
export const EverflowClientSourceIDCookie = 'ef-source-id'
export const EverflowClientAffiliateIDCookie = 'ef-aff-id'
export const EverflowClientOfferIDToken = 'oid'
export const EverflowClientAffiliateIDToken = 'affid'
export const EFTransactionIDToken = '_ef_transaction_id'

// General
export const UTMCampaignToken = 'utm_campaign'
export const UTMCampaignCookie = 'ota-utm-campaign'
export const UTMMediumToken = 'utm_medium'
export const UTMMediumCookie = 'ota-utm-medium'
export const UTMSourceToken = 'utm_source'
export const UTMSourceCookie = 'ota-utm-source'
export const LandingPageUrlCookie = 'ota-lp'
export const PromotionCodeCookie = 'ota-pc'
export const FeatureTestCookie = 'ota-ft' // feature test
export const SovendusFiredCookie = 'ota-sovf' // Sovendus fired
export const OTANoCampaignCookie = 'ota-nocam'

// Snapchat
export const SnapchatClickIdToken = 'ScCid'
export const SnapchatClickIdCookie = 'ota-ScCid'

// Facebook
export const FacebookClickIdToken = 'fbclid'
export const FacebookClickIdCookie = '_fbc'
export const FacebookBrowserIdCookie = '_fbp'

// GTM
export const OTASignupProspectIdCookie = 'ota-spid'
export const OTASignupOutcomeCookie = 'ota-signup-outcome'

// Mcanism
export const McanismToken = 'track_id'
export const McanismCookie = 'ota-mtid'

// Media4Moments
export const Media4MomentsToken = 'm4m'
export const Media4MomentsCookie = 'ota-m4m'

// Attribution
export const AttributionCookie = 'ota-attribution'

// Adtraction
export const AdtractionToken = 'at_gd'
export const AdtractionCookie = 'ota-adtr'

// Manual A/b testing
export const ManualABTestingCookie = 'ota-ab'
export const ManualABTestingCookieTwo = 'ota-ab-2'
export const ManualABTestingCookieThree = 'ota-ab-3'

// Spaaza
export const SpaazaReferralCodeToken = 'ref'
export const SpaazaReferralCodeCookie = 'ota-ref'
